<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-20 p-6">
            <!-- Light version -->
            <img class="dark:hidden w-40" src="https://platform.travelfind.me/uploads/site/logo/xl-holidays-logo-no-tagline.png" alt="Logo image">
            <!-- <img class="dark:hidden w-30 ml-10 mt-2" src="https://platform.travelfind.me/uploads/site/logo/whitestar-logo-light.png" alt="Logo image"> -->
            
            <!-- Dark version -->
            <img class="hidden dark:flex w-full" src="https://platform.travelfind.me/uploads/site/logo/xl-holidays-logo-no-tagline.png" alt="Logo image">
            <!-- <img class="hidden dark:flex w-30 ml-10 mt-2" src="https://platform.travelfind.me/uploads/site/logo/whitestar-logo-light.png" alt="Logo image"> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <search></search>

        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <shortcuts></shortcuts>
            <messages></messages> -->
            <button
                class="ml-4"
                mat-flat-button
                [color]="'primary'"
                (click)="openSearchOptions()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2 mr-1">New</span>
            </button>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button>
            <user [showSummary]="true"></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
            Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <footer></footer>

</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
